/* eslint-env worker */
/* eslint-disable no-restricted-globals */

// Serialized into a Blob worker; all dependencies are supplied in its source.
export default function compressionWorker() {
  self.onmessage = function (event) {
    var id = event.data.id;
    try {
      var result;
      if (event.data.action === 'compress') {
        result = self.LZString.compressToUTF16(JSON.stringify(event.data.data));
      } else {
        result = JSON.parse(self.LZString.decompressFromUTF16(event.data.data));
      }
      self.postMessage({ id: id, success: true, result: result });
    } catch (error) {
      self.postMessage({ id: id, success: false, error: error.message });
    }
  };
  self.postMessage({ ready: true });
}
